import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './request-interceptor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import 'hammerjs';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard.service';
import { MaterialModule } from './material.module';
import { SharedService } from './shared-service.service';
import { LoginComponent } from '../login/login.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MessengerComponent } from '../messenger/messenger.component';
import { MessengerService } from './messenger.service';

import { DialogConfirmationComponent } from './dialog-confirmation/dialog-confirmation.component';

import { DatePipe } from '@angular/common';
import { DisablePropDirective } from './directives/disabled-prop.directive';
import { ShortNumberPipe } from './pipes/short-number.pipe';

import { MomentModule } from 'angular2-moment';


@NgModule({
  declarations: [
    ToolbarComponent,
    LoginComponent,
    DialogConfirmationComponent,
    DisablePropDirective,
    MessengerComponent,
    ShortNumberPipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    HttpModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    ToolbarComponent,
    LoginComponent,
    FormsModule,
    ReactiveFormsModule,
    DialogConfirmationComponent,
    DisablePropDirective,
    ShortNumberPipe,
    MomentModule
  ],
  entryComponents: [
    ToolbarComponent,
    LoginComponent,
    DialogConfirmationComponent
  ],
  providers: [
    AuthGuard, 
    AuthService, 
    SharedService, 
    {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true},
    DatePipe,
    MessengerService
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts